import messageBubbleIcon from '../../../assets/messageBubble.svg';
import { Button } from '../../Button/Button';
import styles from '../Decision.module.css';

const ContactUsDecision = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>
        Almost there!
        <span className={styles.headingSection}>
          Give us a call, and we’ll sort it out for you
        </span>
      </h1>
      <div className={styles.gifContainer}>
        <img
          data-testid="message-bubble-icon"
          src={messageBubbleIcon}
          alt="A speech bubble with an elipses in it."
        />
      </div>
      <div className={styles.body}>
        <div className={styles.bodySection}>
          <p className={styles.bodyContent}>
            The application is currently on hold. Please call us so we can
            confirm the details of your account.
          </p>
        </div>
        <Button
          href="tel:02037780105"
          target="_blank"
          rel="noreferrer"
          className={styles.callUsButton}
        >
          Call us on 020 3778 0105
        </Button>
        <div className={styles.bodySection}>
          <h3 className={styles.bodyHeading}>Get in touch with iwoca</h3>
          <p className={styles.bodyContent}>
            Call us on{' '}
            <a href="tel:02037780105" target="_blank" rel="noreferrer">
              020 3778 0105
            </a>{' '}
            (Monday to Friday 9am - 6pm)
          </p>
          <p className={styles.bodyContent}>
            Email us at{' '}
            <a
              href="mailto:support@iwoca.co.uk"
              target="_blank"
              rel="noreferrer"
            >
              support@iwoca.co.uk
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactUsDecision;
